import { getColor } from 'helpers';
import { Pressed } from 'libs/ui';
import { styled } from 'libs/ui/styled';
import { ColorsDark, ColorsLight, ColorType } from 'libs/ui/theme';

export const ActionStyled = styled(Pressed, {
  shouldForwardProp: (prop) => prop !== 'borderColor',
})<{ borderColor?: ColorType | string }>(({ theme, borderColor }) => ({
  borderRadius: 32,
  width: 36,
  height: 36,
  alignItems: 'center',
  justifyContent: 'center',
  border: `1px solid ${
    borderColor ??
    getColor(theme, {
      light: ColorsLight.gray150,
      dark: ColorsDark.gray150,
    })
  }`,
}));
